export enum PackagingComponentTypesEnum {
    Undefined = 0,
    MainBody = 1,
    Closure = 2,
    Decoration = 3,
    PackagingAid = 4,
    Inlay = 5
}
